export default __webpack_public_path__ + "static/media/ic_eye.41d92b2f.svg";